import { CircleLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "10px",
};

export default function Loader() {
  return <CircleLoader color="green" cssOverride={override}></CircleLoader>;
}
